import type { IconName } from '@freelancer/ui/icon';

export enum ToggleButtonsColor {
  LIGHT = 'light',
  DARK = 'dark',
  TRANSPARENT = 'transparent',
}

interface ValueToggleOption {
  value: string;
  option: string;
}

interface IconToggleOption {
  icon: IconName;
  option: string;
}

export type ToggleOption = ValueToggleOption | IconToggleOption;
